import Spotify2 from './Spotify2'
export default Spotify2
